import { useMediaQuery, useTheme } from '@mui/material';

export function useMobile() {
  return useMedia({ breakpoint: 'md' });
}

export function useTablet() {
  return useMedia({ breakpoint: 'lg' });
}

export default function useMedia({ breakpoint = 'lg', mediaQuery }) {
  const theme = useTheme();
  const matches = useMediaQuery(
    mediaQuery || theme.breakpoints.down(breakpoint),
  );
  return matches;
}
